import { MasterSubCategory } from 'domain/entities/MasterEntity';
import { COMMON } from 'utilities/constants/COMMON';
import { commonHelpers } from 'utilities/helpers';
import { ListedPropertyRoomGetAssessmentDetail } from '../CU-033-01/models/Property';

export const generateAssessmentDetail = (
    options: {
        toiletBath: MasterSubCategory[];
        laundryArea: MasterSubCategory[];
        status: MasterSubCategory[];
        roomLayoutDiv: MasterSubCategory[];
    },
    data?: ListedPropertyRoomGetAssessmentDetail,
) => {
    let bathToiletSeparatedDivName = COMMON.EMPTY;
    let indoorLaundryRoomDivName = COMMON.EMPTY;
    let presentCondDivName = COMMON.EMPTY;
    let roomLayoutDivName = COMMON.EMPTY;

    if (data) {
        const findBathToilet = options.toiletBath.find(
            (element) => element.code + '' === data.bathToiletSeparatedDiv,
        );
        const findpresentCondDiv = options.status.find(
            (element) => element.code + '' === data.presentCondDiv,
        );
        const findindoorLaundryRoomDiv = options.laundryArea.find(
            (element) => element.code + '' === data.indoorLaundryRoomDiv,
        );
        const findroomLayoutDiv = options.roomLayoutDiv.find(
            (element) => element.code + '' === data.roomLayoutDiv,
        );
        bathToiletSeparatedDivName = findBathToilet?.codeName ?? COMMON.EMPTY;
        indoorLaundryRoomDivName = findpresentCondDiv?.codeName ?? COMMON.EMPTY;
        presentCondDivName = findindoorLaundryRoomDiv?.codeName ?? COMMON.EMPTY;
        roomLayoutDivName = findroomLayoutDiv?.codeName ?? COMMON.EMPTY;
    }

    const results = [
        {
            name: '部屋番号',
            value: data?.roomNumber ? data.roomNumber + '号室' : COMMON.EMPTY,
            step: 1,
            field: 'roomNumber',
        },
        {
            name: '専有部分所在階',
            value:
                data?.occupiedFloor || data?.occupiedFloor === 0
                    ? data.occupiedFloor + '階'
                    : COMMON.EMPTY,
            step: 1,
            field: 'occupiedFloor',
        },
        {
            name: '専有面積',
            value: data?.occupiedArea
                ? commonHelpers.formatNumberMoney(Number(data.occupiedArea)) + ' m²'
                : COMMON.EMPTY,
            step: 1,
            field: 'occupiedArea',
        },
        {
            name: 'バルコニー面積',
            value: data?.balconyArea ? data.balconyArea + ' m²' : COMMON.EMPTY,
            step: 1,
            field: 'balconyArea',
        },
        {
            name: '間取り',
            value: roomLayoutDivName,
            step: 2,
            field: 'roomLayoutDiv',
        },
        {
            name: 'バス・トイレ別',
            value: bathToiletSeparatedDivName,
            step: 2,
            field: 'bathToiletSeparatedDiv',
        },
        {
            name: '室内洗濯機置き場',
            value: presentCondDivName,
            step: 2,
            field: 'presentCondDiv',
        },
        {
            name: '備考',
            value: data?.notes ?? COMMON.EMPTY,
            step: 2,
            field: 'notes',
        },
        {
            name: '家賃',
            value:
                data?.rent || data?.rent === 0
                    ? commonHelpers.formatNumberMoney(data.rent) + ' 円'
                    : COMMON.EMPTY,
            step: 3,
            field: 'rent',
        },
        {
            name: '共益費',
            value:
                data?.commonServiceFee || data?.commonServiceFee === 0
                    ? commonHelpers.formatNumberMoney(data.commonServiceFee) + ' 円'
                    : COMMON.EMPTY,
            step: 3,
            field: 'commonServiceFee',
        },
        {
            name: '現在の状況',
            value: indoorLaundryRoomDivName,
            step: 3,
            field: 'indoorLaundryRoomDiv',
        },
        {
            name: '管理費',
            value: data?.managementFee
                ? commonHelpers.formatNumberMoney(data.managementFee) + ' 円'
                : COMMON.EMPTY,
            step: 4,
            field: 'managementFee',
        },
        {
            name: '修繕積立金',
            value:
                data?.renovationDeposit || data?.renovationDeposit === 0
                    ? commonHelpers.formatNumberMoney(data.renovationDeposit) + ' 円'
                    : COMMON.EMPTY,
            step: 4,
            field: 'renovationDeposit',
        },
        {
            name: 'その他費用',
            value:
                data?.otherExpenses || data?.otherExpenses === 0
                    ? commonHelpers.formatNumberMoney(data.otherExpenses) + ' 円'
                    : COMMON.EMPTY,
            step: 4,
            field: 'otherExpenses',
        },
        {
            name: 'その他費用備考',
            value: data?.otherExpensesNotes ?? COMMON.EMPTY,
            step: 4,
            field: 'otherExpensesNotes',
        },
        {
            name: '残債',
            value:
                data?.loanBalance || data?.loanBalance === 0
                    ? commonHelpers.formatNumberMoney(data.loanBalance) + ' 円'
                    : COMMON.EMPTY,
            step: 5,
            field: 'loanBalance',
        },
        {
            name: '所有年数',
            value:
                data?.ownshipYear || data?.ownshipYear === 0
                    ? data?.ownshipYear + '年'
                    : COMMON.EMPTY,
            field: 'ownshipYear',
            step: 5,
        },
    ];
    return results;
};
